module.exports = __webpack_public_path__ + "fonts/Roboto-Regular-webfont.30799efa.eot";